export default __webpack_public_path__ + "static/media/BasiliaLovelace.da42923d.png";